import { browser as bowser } from 'bowser';
import qs from 'qs';

const Browser = {
  /** [#VCO-7881] - Fixes
   * @return {Boolen} {true/false}
   */
  checkIE11OrEdgeBrowser: () => {
    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    const edge = ua.indexOf('Edge/');
    let isIE11OrEdge = '';

    if (trident > 0) {
      const rv = ua.indexOf('rv:');
      isIE11OrEdge = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    if (edge > 0) {
      isIE11OrEdge = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    return isIE11OrEdge >= 11;
  },

  checkPhoneBrowser: () => /Mobile/i.test(window.navigator.userAgent),

  extractQueryParams: qstr => {
    const queryString = qstr || window.location.search.substring(1);
    return qs.parse(queryString);
  },

  getRawQueryString: () => {
    const search = window.location.search || '';
    return search.slice(search.indexOf('?') + 1);
  },

  getUserAgent: () => {
    const ua = window.navigator.userAgent;
    return ua ? ua.toLowerCase() : '';
  },

  isAndroidMobile: () => {
    const ua = Browser.getUserAgent();
    return (
      ua.indexOf('android') > -1 && ua.indexOf('mozilla/5.0') > -1 && ua.indexOf('applewebkit') > -1
    );
  },

  isAndroidWebview: () => {
    // https://developer.chrome.com/multidevice/user-agent#webview_user_agent
    return /wv/i.test(window.navigator.userAgent.toLowerCase());
  },

  isChromeOniOS: () => {
    const ua = Browser.getUserAgent();
    return /iphone|ipod|ipad/i.test(ua) && /CriOS/i.test(ua);
  },

  /**
   * Returns TRUE if the browser is MS Edge
   * @returns {boolean}
   */
  isEdge: () => {
    return /(?=^.*edge)/i.test(Browser.getUserAgent());
  },

  /**
   * Returns TRUE if the browser is safari or edge
   * @returns {boolean}
   */
  isEdgeOrSafari: () => Browser.isEdge() || Browser.isSafari(),

  isHybridImplementation: () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isVisaSDKLite = userAgent.indexOf('vco_sdk') !== -1;
    const isVisaHybridSDKLite = userAgent.indexOf('vco_hsdk') !== -1;

    return (
      isVisaSDKLite || isVisaHybridSDKLite || Browser.isIOSWebView() || Browser.isAndroidWebview()
    );
  },

  isIOSAndroid: () => {
    const ua = Browser.getUserAgent();
    return /iPad|iPhone|iPod|Android/.test(ua) && !window.MSStream;
  },

  isIOSWebView: () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const safari = /safari/i.test(userAgent);
    const iOS = /iphone|ipod|ipad/i.test(userAgent);
    return iOS && !safari;
  },

  isMobileSafari: () => {
    const ua = Browser.getUserAgent();
    const iOS = /iP(ad|od|hone)/i.test(ua);
    const webkit = /WebKit/i.test(ua);
    return iOS && webkit && !/CriOS/i.test(ua);
  },

  /**
   * Returns TRUE if the browser is Safari
   * @returns {boolean}
   */
  isSafari: () => {
    return /^((?!chrome|android).)*safari/i.test(Browser.getUserAgent());
  },

  supportsSameSiteNone: () => {
    // F15857 - cases which samesite=none is supported
    //  1. browser is chrome - at time of this code's implementation, only chome >= 80 requires samesite=none
    //  2. chrome version > 66 (https://www.chromium.org/updates/same-site/incompatible-clients)
    if (bowser.chrome && bowser.version > 66) {
      return true;
    }

    return false;
  }
};

export default Browser;
